<template>
  <div class="customer-review mt-n2">
    <index-view title="Danh sách nhân viên" :filters="filters" :getData="getData" :headers="mainHeaders">
      <template #viewSection="{ item }">
        <detail :item="item"></detail>
      </template>
    </index-view>
  </div>
</template>

<script>

import IndexView from '../../../components/CommonView/IndexView.vue';
import { getFamily } from './api'
import { main } from './header'
// import Detail from './Detail.vue'
export default {
  name: "CustomerReview",
  components: {
    IndexView,
    // Detail,
  },
  computed: {
    mainHeaders () {
      return main(this.filters)
    }
  },
  data() {
    return {
      filters: [
        {name: 'employeeCode', label:'Mã NS', type: 'text', value: '' },
        {name: 'employeeName', label:'Tên NS', type: 'text', value: '' },
        {name: 'memberEmployeeCode', label:'Mã NS (người thân)', type: 'text', value: '' },
        {name: 'memberName', label:'Tên người thân', type: 'text', value: '' },
      ],
      // mainData: []
    }
  },
  methods: {
    getData: getFamily
  }
}
</script>